<template>
  <div class="bomCartBtns__wrapper" v-if="getIsAllSectionsCompleted">
    <div class="bomCartBtns__addToCart" v-if="!getIsUserLimited">
      <BaseButton
        class="bomCartBtns__cartBtn"
        :disabled="buttonsDisabled"
        :isPrimary="true"
        buttonid="add-to-cart-pp"
        @onClick="addToCart"
        ><span v-if="buttonsDisabled" class="spinner btn-primary spinning"
          ><span></span
        ></span>
        <span v-else>ADD TO CART</span>
      </BaseButton>
    </div>
    <div class="btn-spacing" v-else>
        <BaseButton class="addToCart__disabled"
                    :disabled="true"
                    :isPrimary="true"
                    buttonid="add-to-cart-pp">ADD TO CART
        </BaseButton>
    </div>
    <div class="bomCartBtns__addToQuote">
      <BaseButton
        class="bomCartBtns__quoteBtn"
        :disabled="buttonsDisabled"
        :isPrimary="false"
        buttonid="add-to-quote-pp"
        @onClick="addToQuote"
      >
        <i class="material-icons">note_add</i>
        <span class="bomCartBtns__btnText">Add To Quote</span>
      </BaseButton>
      <div class="bomCartBtns__limited_user_text" v-show="getIsUserLimited">
        {{ getLimitedUserText }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { legacyIsQuote } from "../../../legacy";

import BaseButton from "../../base/BaseButton";

export default {
  data() {
    return {
      buttonsDisabled: false
    };
  },
  components: {
    BaseButton
  },
  computed: {
    ...mapGetters("product", [
      "getProductSku",
      "isSkuPage",
      "hasPrice",
      "getSelectedOptions",
      "getProductTitle"
    ]),
    ...mapGetters("user", ["getIsUserLimited"]),
    ...mapGetters("enhancedproduct", [
      "getIsAllSectionsCompleted",
      "getProductVariantCharacteristics",
      "getcustomHPLFormData",
      "getEnhancedImage",
      "getEnhancedProductTitle"
    ]),
    ...mapGetters("enhancedBom", [
      "getBomSourceOfTruthWithoutThirdPartyProducts",
      "getBomPartList",
      "getTotalPrice",
      "getTotalMSRP",
      "getCurrencyCode",
      "getCurrencySymbol"
    ]),
    getLimitedUserText() {
      return "Please contact Sales Ops at av.sales.operations@legrand.com if you need the ability to purchase products.";
    },
    wecoCallFailureMessage() {
      return `Uh oh. Something went wrong that prevented these items from being added to your cart. Please try adding them to your cart again.`;
    }
  },
  methods: {
    hasCurrentQuote() {
      return legacyIsQuote() || this.getIsUserLimited;
    },
    addToQuote() {
    var qtyList ="";    
    for (var i = 0; i < this.getBomSourceOfTruthWithoutThirdPartyProducts.length; i++) {
        qtyList = qtyList + this.getBomSourceOfTruthWithoutThirdPartyProducts[i].DefaultQuantity + ",";        
      }
      var quantityList;
      if(qtyList.length > 1 ){
        quantityList = qtyList.substring(0,qtyList.length-1).split(",");
      } else{
      quantityList = 1;
      }      
      const fireAddToQuoteModalPopUpEvent = new CustomEvent(
        "fireAddToQuoteModalPopUp",
        {
          detail: {
            productNumber: this.getBomPartList,
            titleQuantity: this.getBomPartList.length,
            quantity: quantityList,
            scId: this.getBomPartList,
            productTitle: this.getEnhancedProductTitle,
            imageUrl: this.getEnhancedImage[0].Url,
            imageAlt: this.getEnhancedImage[0].Title,
            productPrice: this.getTotalPrice,
            productMsrp: this.getTotalMSRP,
            currency: this.getCurrencySymbol,
            currencyCode: this.getCurrencyCode,
            brandLogo: "this.getProductSeries.Brands[0].Url"
          }
        }
      );
      document.body.dispatchEvent(fireAddToQuoteModalPopUpEvent);
    },
    addToCart() { 
    let qtyList ="";
    
    for (var i = 0; i < this.getBomSourceOfTruthWithoutThirdPartyProducts.length; i++) {
        qtyList = qtyList + this.getBomSourceOfTruthWithoutThirdPartyProducts[i].DefaultQuantity + ",";        
      }
      let quantityList;
      if(qtyList.length > 1 ){

        quantityList = qtyList.substring(0,qtyList.length-1).split(",");
      } else{
      quantityList = 1;
      }
      const fireAddToCartModalPopUpEvent = new CustomEvent(
        "fireAddToCartModalPopUp",
        {
          detail: {
            productNumber: this.getBomPartList,
            titleQuantity: this.getBomPartList.length,
            quantity: quantityList,
            scId: this.getBomPartList,
            productTitle: this.getEnhancedProductTitle,
            imageUrl: this.getEnhancedImage[0].Url,
            imageAlt: this.getEnhancedImage[0].Title,
            productPrice: this.getTotalPrice,
            productMsrp: this.getTotalMSRP,
            currency: this.getCurrencySymbol,
            currencyCode: this.getCurrencyCode,
            brandLogo: "this.getProductSeries.Brands[0].Url"
          }
        }
      );
      document.body.dispatchEvent(fireAddToCartModalPopUpEvent);
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    addCustomHPLToVariantChar() {
      let productVariantCharacteristics = {
        ISPRODUCTVARIANTWITHCHARS: "Y",
        VARIANT_CHARACTERISTICS: []
      };
      if (this.getcustomHPLFormData.length > 0) {
        for (var j = 0; j < this.getcustomHPLFormData.length; j++) {
          if (this.getcustomHPLFormData[j].RulesKey == "C3CUDoorFinishId") {
            var valueData;
            if (this.getcustomHPLFormData[j].Manufacturer !== null) {
              valueData = `${this.getcustomHPLFormData[j].Manufacturer} ${this.getcustomHPLFormData[j].ColorNumber} ${this.getcustomHPLFormData[j].ColorName}`;
            } else {
              valueData = `${this.getcustomHPLFormData[j].ColorNumber} ${this.getcustomHPLFormData[j].ColorName}`;
            }
            productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
              KEY: "C3K_DOOR_COLOR_CUSTOM",
              VALUE: valueData
            });
          } else {
            productVariantCharacteristics.VARIANT_CHARACTERISTICS.push({
              KEY: "FRN_COLOR_CUSTOM",
              VALUE: valueData
            });
          }
        }
        this.$store.dispatch(
          "enhancedproduct/setProductVariantCharacteristics",
          {
            productVariantCharacteristics: productVariantCharacteristics
          }
        );
      }
    }
  }
}; // END export default
</script>

<style lang="scss" scoped>
.bomCartBtns {
  &__wrapper {
    font-family: $font-family-sans-serif-regular;

    @include media-breakpoint-up(lg) {
      margin: 25px 0 0 0;
      display: grid;
    }
  }
  &__addToQuote {
    @include media-breakpoint-up(md) {
      flex: 1;
    }
  }

  &__limited_user_text {
    margin-top: 25px;
    font-family: $font-weight-medium;
    font-style: italic;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: $letter-spacing-sm;
    color: $gray-darker;
    line-height: 1.25em;
    text-align: left;
  }
  &__quoteBtn {
    transition: all 0.3s ease;
    border-color: $primary;
    color: $primary;
    &:hover {
        background-color: $primary !important;
        border-color: $primary !important;
    }
    &:focus {
        background-color: $primary !important;
        border-color: $primary !important;
        color: $white !important;
    }
    &:hover .bomCartBtns__btnText {
      color: $white !important;
    }
  }
  &__quoteBtn .material-icons {
    font-size: 17px;
    margin-right: 7px;
  }
  &__btnText {
    font-weight: bold;
    &:focus {
        color: $white;
    }
  }
  &__addToCart {
    margin-bottom: 25px;
    @include media-breakpoint-up(lg) {
      flex: 1;
      margin-bottom: 16px;
    }
  }
}
.addToCart__disabled {
    background: #e6e6e6;
    border: none !important;
    border-radius: 0;
    color: #545454;
    font-weight: 700;
    pointer-events: none;
    opacity: .5;
}
.btn-spacing {
    margin-bottom: 16px;
}
</style>
